import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=780b478b&scoped=true&"
import script from "./MessageForm.vue?vue&type=script&lang=js&"
export * from "./MessageForm.vue?vue&type=script&lang=js&"
import style0 from "./MessageForm.vue?vue&type=style&index=0&id=780b478b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b478b",
  null
  
)

export default component.exports